
export enum Tool {
  CUBE = 'cube',
  FACE = 'face',
  SEGMENT = 'segment',
  POINTER = 'pointer',
  ERASER = 'eraser',
  BRUSH = 'brush',
  ROTATOR = 'rotator'
}

export enum Mode {
  CREATION = 'creation',
  INSPECTION = 'inspection'
}

export type Point3D = {
  x: number;
  y: number;
  z: number;
};

export type Orientation = 'top' | 'left' | 'right';

export interface IsometricObject {
  id: string;
  type: 'cube' | 'face' | 'segment';
  position: Point3D;
  color: string;
  orientation?: Orientation; // For faces
  endPosition?: Point3D; // For segments
}

export interface IsometricState {
  objects: IsometricObject[];
  rotation: { x: number; y: number };
  zoom: number;
  showAxes: boolean;
  transparent: boolean;
  view2D: boolean;
}
